'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'images';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f302';
var svgPathData = 'M560 48l0 180.7-90.3-90.3-5.7-5.7-5.7 5.7L304 292.7l-90.3-90.3-5.7-5.7-5.7 5.7L112 292.7 112 48l448 0zM112 368l0-52.7 96-96L292.7 304 229 367.7c-.1 .1-.2 .2-.3 .3L112 368zm448 0l-308.7 0 58.3-58.3L464 155.3l96 96L560 368zM112 32L96 32l0 16 0 320 0 16 16 0 448 0 16 0 0-16 0-320 0-16-16 0L112 32zm136 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 88a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM16 128L0 128l0 16L0 464l0 16 16 0 448 0 16 0 0-16 0-48-16 0 0 48L16 464l0-320 48 0 0-16-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImages = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;